import _ from 'underscore';

import { BridgeClientNotRunningNotificationsSectionSpecs } from '~src/settings/bridge-settings/sections/BridgeClientNotRunningNotificationsSection';
import { BridgeDefaultRemoteAgentsSectionSpecs } from '~src/settings/bridge-settings/sections/BridgeDefaultRemoteAgentsSection';
import { BridgeNetworkAllowlistSpecs } from '~src/settings/bridge-settings/sections/bridgeNetworkAllowlist/BridgeNetworkAllowlist';
import { BridgePoolingSectionSpecs } from '~src/settings/bridge-settings/sections/BridgePoolingSection';
import { BridgeSettingsSummarySectionSpecs } from '~src/settings/bridge-settings/sections/BridgeSettingsSummarySection';
import { BridgeUnassignedRemoteAgentsSectionSpecs } from '~src/settings/bridge-settings/sections/BridgeUnassignedRemoteAgentsSection';
import {AnalyticsExtensionsServerSectionSpec} from '~src/settings/extensions-settings/analytics/AnalyticsExtensionsServerSection';
import {AnalyticsExtensionsSiteSectionSpec} from '~src/settings/extensions-settings/analytics/AnalyticsExtensionsSiteSection';
import { PrepExtensionsSiteSectionSpecs } from '~src/settings/extensions-settings/prep/PrepExtensionsSiteSection';
import {KMSInOnlineSpecs} from '~src/settings/general-settings/components/sections/kms-in-online/KMSInOnlineSection';
import { MobileGeneralSettingsSectionSpecs } from '~src/settings/mobile-settings/sections/MobileGeneralSettingsSection';

import { ExtensionsServerSectionSpecs } from '../../extensions-settings/dashboard/ExtensionsServerSection';
import { ExtensionsSiteSectionSpecs } from '../../extensions-settings/dashboard/ExtensionsSiteSection';
import { MobileSecuritySettingsSectionSpecs } from '../../mobile-settings/sections/MobileSecuritySettingsSection';
import { ActiveDirectorySyncSectionSpecs } from './sections/active-directory-sync/ActiveDirectorySyncSection';
import { AdminInsightsPublishFrequencySpecs } from './sections/admin-insights/AdminInsightsPublishFrequencySection';
import { AskDataSectionSpecs } from './sections/ask-data/AskDataSection';
import { CollectionsSettingSectionSpecs } from './sections/collections/CollectionsSettingSection';
import { CommentingSettingSectionSpecs } from './sections/commenting/CommentingSettingSection';
import { ConnectedClientsSettingSectionSpecs } from './sections/connected-clients/ConnectedClientsSettingSection';
import { ContentMigrationAuthorizationSectionSpecs } from './sections/content-migration/ContentMigrationAuthorization';
import { EmbeddedCredentialsSectionSpecs } from './sections/credentials/EmbeddedCredentialsSection';
import { ManagedKeychainCleanupSectionSpecs } from './sections/credentials/ManagedKeychainCleanup';
import { SavedCredentialsSpecs } from './sections/credentials/SavedCredentialsSection';
import { CustomDomainSpecs } from './sections/custom-domain/CustomDomainSettingRegistry';
import { AutomaticAccessSectionSpecs } from './sections/data-catalog/AutomaticAccessSection';
import { CatalogingSectionSpecs } from './sections/data-catalog/CatalogingSection';
import { SensitiveLineageDataSectionSpecs } from './sections/data-catalog/SensitiveLineageDataSection';
import { DataChangeRadarSectionSpecs } from './sections/data-change-radar/DataChangeRadarSection';
import { DataAlertsSectionSpecs } from './sections/data-driven-alert/DataAlertsSection';
import { DataOrientationAdminSettingsSectionSpecs } from './sections/data-orientation/DataOrientationAdminSettingsSection';
import { DataQualitySubscriptionSectionSpec } from './sections/data-quality-warning/DataQualitySubscriptionSection';
import { DataStorySectionSpecs } from './sections/data-story/DataStorySection';
import { DataAccelerationSectionSpecs } from './sections/dataAcceleration/DataAccelerationSection';
import { ExplainDataSectionSpecs } from './sections/explain-data/ExplainDataSection';
import { ExternalActionsWorkflowsSectionSpecs } from './sections/external-actions-workflows/ExternalActionsWorkflowsSection';
import { AutoSuspendExtractRefreshSectionSpecs } from './sections/extract/AutoSuspendExtractRefreshSection';
import { ExtractEncryptionSectionSpecs } from './sections/extract/ExtractEncryptionSection';
import { SiteTimeZoneSectionSpecs } from './sections/extract/SiteTimeZoneSection';
import { NotifySiteAdminsOnThrottleSpec } from './sections/extract-quota-notification/NotifySiteAdminsOnThrottleSection';
import { ServerGuestAccessSectionSpecs, SiteGuestAccessSectionSpecs } from './sections/guest-access/GuestAccessSection';
import { LinkedTaskServerSettingSpecs } from './sections/linked-task/LinkedTaskServerSettingSection';
import { LinkedTaskSiteSettingSpecs } from './sections/linked-task/LinkedTaskSiteSettingSection';
import { ManageUsersSectionSpecs } from './sections/manage-users-section/ManageUsersSection';
import { MetricsContentTypeSpecs } from './sections/metrics/MetricsContentTypeSection';
import { MobileSectionSpecs } from './sections/mobile/MobileSection';
import { OAuthClientsRegistrySectionSpecs } from './sections/oauth-clients-registry/OAuthClientsRegistry';
import { PersonalSpaceSectionSpecs } from './sections/personal-space/PersonalSpaceSection';
import { FlowParametersServerSettingSpecs } from './sections/prep/FlowParametersServerSettingSection';
import { FlowParametersSiteSettingSpecs } from './sections/prep/FlowParametersSiteSettingSection';
import { FlowSubscriptionsSiteSettingSpecs } from './sections/prep/FlowSubscriptionsSiteSettingSection';
import { PrepConductorSpecs } from './sections/prep/PrepConductorSection';
import { RecommendationsTrainingSectionSpecs } from './sections/recommendation/RecommendationsTrainingSection';
import { VizRecommendationsSectionSpecs } from './sections/recommendation/VizRecommendationsSection';
import { RequestAccessSectionSpecs } from './sections/request-access/RequestAccessSection';
import { RevisionHistorySectionSpecs } from './sections/revision-history/RevisionHistorySection';
import { RunNowServerSettingSpec } from './sections/run-now/RunNowServerSettingSection';
import { RunNowSiteSettingSpec } from './sections/run-now/RunNowSiteSettingSection';
import { SharingSectionSpecs } from './sections/sharing/SharingSection';
import { SignInNoteSpec } from './sections/sign-in-customization/SignInNoteSection';
import { SiteInviteNotificationSpecs } from './sections/site-invite-notification/SiteInviteNotificationSection';
import { SiteNameAndIdSpecs } from './sections/site-name-and-id/SiteNameAndIdSection';
import { UpdateSiteLogoFormSpecs } from './sections/siteLogo/forms/UpdateSiteLogoForm';
import { ServerStartPageSpecs, SiteStartPageSpecs } from './sections/start-page/StartPageSection';
import { StorageSectionSpecs } from './sections/storage-quota/StorageSection';
import { SubscriptionsSpec } from './sections/subscription/SubscriptionsSection';
import { TaggingSectionSpecs } from './sections/tagging/TaggingSection';
import { CrossDataBaseJoinsSectionSpecs } from './sections/unowned-settings/CrossDataBaseJoinsSection';
import { EmailSettingsSpecs } from './sections/unowned-settings/EmailSettingsSection';
import { LanguageAndLocaleSectionSpecs } from './sections/unowned-settings/LanguageAndLocaleSection';
import { PerformanceMetricsSectionSpecs } from './sections/unowned-settings/PerformanceMetricsSection';
import { SiteAvailabilitySpecs } from './sections/unowned-settings/SiteAvailabilitySection';
import { SupportAccessSectionSpecs } from './sections/unowned-settings/SupportAccessSection';
import { WebAuthoringSpecs } from './sections/unowned-settings/WebAuthoringSection';
import { NotificationFlowRunsSpecs } from './sections/user-notification/NotificationsFlowRunsSection';
import { UserNotificationsSiteSettingsSectionSpecs } from './sections/user-notification/UserNotificationsSiteSettingsSection';
import { UserVisibilitySpecs } from './sections/user-visibility/UserVisibilitySection';
import { WebPageObjectsSectionSpecs } from './sections/web-page-objects/WebPageObjectsSection';
import { CacheWarmupSectionSpecs } from './sections/workbook-performance/CacheWarmupSection';
import { ComponentSpecs } from './SettingsComponentRegistryFunctions';

export function createComponentRegistry(...specArray: ComponentSpecs<any>[]) {
  const result: _.Dictionary<ComponentSpecs<any>> = {};
  specArray.forEach(spec => result[spec.name] = spec);
  return result;
}

/**
 * All react-based sections in the settings page should be added to this object to allow them to be named in
 * the pug file while migrating, and to dynamically load them later on
 */
export const SettingsComponentRegistry = createComponentRegistry(
  FlowSubscriptionsSiteSettingSpecs,
  ConnectedClientsSettingSectionSpecs,
  LanguageAndLocaleSectionSpecs,
  CrossDataBaseJoinsSectionSpecs,
  SupportAccessSectionSpecs,
  CommentingSettingSectionSpecs,
  RequestAccessSectionSpecs,
  DataAlertsSectionSpecs,
  VizRecommendationsSectionSpecs,
  SharingSectionSpecs,
  WebPageObjectsSectionSpecs,
  AutomaticAccessSectionSpecs,
  SiteNameAndIdSpecs,
  SiteAvailabilitySpecs,
  PrepConductorSpecs,
  LinkedTaskSiteSettingSpecs,
  LinkedTaskServerSettingSpecs,
  WebAuthoringSpecs,
  StorageSectionSpecs,
  RevisionHistorySectionSpecs,
  ManageUsersSectionSpecs,
  ServerGuestAccessSectionSpecs,
  SiteGuestAccessSectionSpecs,
  PerformanceMetricsSectionSpecs,
  CatalogingSectionSpecs,
  TaggingSectionSpecs,
  CacheWarmupSectionSpecs,
  ManagedKeychainCleanupSectionSpecs,
  AutoSuspendExtractRefreshSectionSpecs,
  EmailSettingsSpecs,
  DataAccelerationSectionSpecs,
  SiteInviteNotificationSpecs,
  UserVisibilitySpecs,
  ServerStartPageSpecs,
  SiteStartPageSpecs,
  PersonalSpaceSectionSpecs,
  SubscriptionsSpec,
  NotificationFlowRunsSpecs,
  MobileSectionSpecs,
  MobileGeneralSettingsSectionSpecs,
  MobileSecuritySettingsSectionSpecs,
  NotifySiteAdminsOnThrottleSpec,
  AskDataSectionSpecs,
  ExplainDataSectionSpecs,
  DataChangeRadarSectionSpecs,
  MetricsContentTypeSpecs,
  SensitiveLineageDataSectionSpecs,
  FlowParametersServerSettingSpecs,
  FlowParametersSiteSettingSpecs,
  RunNowServerSettingSpec,
  RunNowSiteSettingSpec,
  ExtractEncryptionSectionSpecs,
  UserNotificationsSiteSettingsSectionSpecs,
  SavedCredentialsSpecs,
  OAuthClientsRegistrySectionSpecs,
  ActiveDirectorySyncSectionSpecs,
  SiteTimeZoneSectionSpecs,
  SignInNoteSpec,
  UpdateSiteLogoFormSpecs,
  RecommendationsTrainingSectionSpecs,
  EmbeddedCredentialsSectionSpecs,
  BridgeSettingsSummarySectionSpecs,
  BridgeClientNotRunningNotificationsSectionSpecs,
  BridgePoolingSectionSpecs,
  BridgeDefaultRemoteAgentsSectionSpecs,
  BridgeNetworkAllowlistSpecs,
  BridgeUnassignedRemoteAgentsSectionSpecs,
  ExtensionsServerSectionSpecs,
  ExtensionsSiteSectionSpecs,
  PrepExtensionsSiteSectionSpecs,
  AnalyticsExtensionsSiteSectionSpec,
  AnalyticsExtensionsServerSectionSpec,
  DataQualitySubscriptionSectionSpec,
  AdminInsightsPublishFrequencySpecs,
  KMSInOnlineSpecs,
  ContentMigrationAuthorizationSectionSpecs,
  CollectionsSettingSectionSpecs,
  DataStorySectionSpecs,
  ExternalActionsWorkflowsSectionSpecs,
  DataOrientationAdminSettingsSectionSpecs,
  CustomDomainSpecs
);
